import { NoData } from "./EmptyStates";

export const Page404 = () => {
  return (
    <div className="h-screen w-screen flex justify-center items-center">
      <NoData isError={true} text="Page not found!" />
    </div>
  );
};
